@import (reference) '../../../../../../constants/spacing.module.less';

.help-text {
  color: var(--grey-600);
  margin-left: @space-28;
}

.email-input {
  flex: 1;
  max-width: 300px;
  margin-left: @space-28;
}

.threshold-row {
  align-items: center;
  margin-left: @space-28;
}

.threshold-input {
  width: 80px;
}
